import {useEffect} from 'react'

const useAriaHiddenOnIframesAndDividers = () => {
    useEffect(() => {
        const setAriaHidden = () => {
            // Set aria-hidden on all Chakra UI dividers
            document.querySelectorAll('hr.chakra-divider').forEach((divider) => {
                divider.setAttribute('aria-hidden', 'true')
                divider.removeAttribute('role')
                divider.removeAttribute('aria-orientation')
            })
            // Third-party tracking pixels (e.g. adnxs) are appended straight to <body> without alt
            document.querySelectorAll('body > img:not([alt])').forEach((pixel) => {
                pixel.setAttribute('alt', '')
                pixel.setAttribute('aria-hidden', 'true')
            })
        }
        setAriaHidden()
        const observer = new MutationObserver(setAriaHidden)
        observer.observe(document.body, {childList: true, subtree: true})
        return () => observer.disconnect()
    }, [])
}

export default useAriaHiddenOnIframesAndDividers
